/**
 * @file 控制台显示信息
 * @author feibinyang
 */

export function error(msg) {
    console && console.error(msg);
}

export function warn(msg) {
    console && console.warn(msg);
}

export function log(msg) {
    console && console.log(msg);
}
